import type { IBaseControlSetting } from '~/presentation/reports/common/type';

import { EControlType, EReportControlId } from '~/presentation/reports/common/type';
import { useCGTemplateListing } from '~/modules/campaign-group-template';
import { useCampaignTemplateListing } from '~/modules/campaign-template';
import { useCampaignPriceListing } from '~/modules/campaign-price';
import { useCampaignUrlListing } from '~/modules/campaign-url-redirect';
import { SelectCampaignContent } from './SelectCampaignContent';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { SelectBase } from '../../SelectBase';
import { useMemo } from 'react';
import { cls } from '~/utils';

export interface IControlSelectCampaign extends IBaseControlSetting {
  type: EControlType.SELECT_CAMPAIGN;
}

export const SelectCampaign: React.FC<IControlSelectCampaign> = (props) => {
  const campaignListing = useCampaignTemplateListing();
  const campaignGroupTemplateListing = useCGTemplateListing();
  const campaignPriceListing = useCampaignPriceListing();
  const campaignUrlListing = useCampaignUrlListing();

  const dataCampaign = useMemo(() => {
    const campaigns = campaignListing.data.filter(
      (campaign) => campaign.status !== CAMPAIGN_STATUS.DRAFT,
    );
    return campaigns.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [campaignListing.data]);

  const dataMultipageCampaign = useMemo(() => {
    const campaignsGroup = campaignGroupTemplateListing.data.filter(
      (campaign) => campaign.status !== CAMPAIGN_STATUS.DRAFT,
    );

    return campaignsGroup.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [campaignGroupTemplateListing.data]);

  const dataPriceCampaign = useMemo(() => {
    const campaigns = campaignPriceListing.data.filter(
      (campaign) => campaign.status !== CAMPAIGN_STATUS.DRAFT,
    );
    return campaigns.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [campaignPriceListing.data]);

  const dataUrlCampaign = useMemo(() => {
    const campaigns = campaignUrlListing.data.filter(
      (campaign) => campaign.status !== CAMPAIGN_STATUS.DRAFT,
    );
    return campaigns.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [campaignUrlListing.data]);

  const optionsMap = {
    [EReportControlId.SINGLE_CAMPAIGN]: dataCampaign,
    [EReportControlId.GROUP_CAMPAIGN]: dataMultipageCampaign,
    [EReportControlId.PRICE_CAMPAIGN]: dataPriceCampaign,
    [EReportControlId.URL_CAMPAIGN]: dataUrlCampaign,
  };

  return (
    <SelectBase
      label={props.label}
      textVariant="bodySm"
      disabled={props.disabled}
      id={props.id}
      type={EControlType.SELECT_BASE}
      dependentControls={props.dependentControls}
      info={props.info}
    >
      <div className={cls('flex gap-[6px] mt-[6px] [&>*]:min-w-0')}>
        {props.configs?.map((config, index) => {
          return <SelectCampaignContent key={index} config={config} optionsMap={optionsMap} />;
        })}
      </div>
    </SelectBase>
  );
};
